<template>
  <div v-if="open" class="mv-filter-panel">
    <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px">
      <label style="display: flex; flex-direction: column; gap: 6px; min-width: 0">
        <span class="field-label">Metadata set</span>
        <span class="mv-select-wrap" style="display: flex">
          <select class="mv-input" :value="set ? set.id : ''" @change="$store.state.selectMetadataSet($event.target.value)">
            <option value="">None</option>
            <option v-for="s in $store.state.metadataSets" :key="s.id" :value="s.id">{{ s.label }}</option>
          </select>
        </span>
      </label>

      <label v-for="item in items" :key="item.id || item.label" style="display: flex; flex-direction: column; gap: 6px; min-width: 0">
        <span class="field-label" ellipsis>{{ item.label }}</span>
        <input
          v-if="TEXT_TYPES.includes(item.type)"
          class="mv-input"
          placeholder="contains…"
          :value="item.value"
          @input="setValue(item, $event.target.value || undefined, true)" />
        <input
          v-else-if="item.type === 'TAG'"
          class="mv-input"
          placeholder="tag, tag…"
          :value="(item.value || []).join(', ')"
          @input="setValue(item, splitTags($event.target.value), true)" />
        <input
          v-else-if="item.type === 'DATE'"
          type="date"
          class="mv-input"
          :value="item.value"
          @change="setValue(item, $event.target.value || undefined)" />
        <span v-else-if="item.type === 'DROPDOWN' || item.type === 'CHECKBOX'" class="mv-select-wrap" style="display: flex">
          <select class="mv-input" :value="item.value" @change="setValue(item, $event.target.value || undefined)">
            <option :value="undefined">Any</option>
            <template v-if="item.type === 'DROPDOWN'">
              <option v-for="option in item.allowedValues" :key="option" :value="option">{{ option }}</option>
            </template>
            <option v-else value="true">Yes</option>
          </select>
        </span>
        <v-select
          v-else-if="item.type === 'MULTISELECT'"
          :items="item.allowedValues"
          :value="item.value"
          multiple
          dense
          hide-details
          attach
          @change="setValue(item, $event.length ? $event : undefined)"></v-select>
      </label>
    </div>

    <div style="display: flex; align-items: center; gap: 8px">
      <span class="mono" style="font-size: 10.5px; color: var(--text-faint)">{{ plural(matches, "match", "matches") }}</span>
      <button type="button" class="mv-ghost mv-ghost--bare" style="margin-left: auto; padding: 0 8px" @click="reset()">Reset</button>
    </div>
  </div>

  <!-- collapsed: the active criteria as removable chips -->
  <div v-else-if="criteria.length" style="display: flex; flex-wrap: wrap; gap: 6px">
    <span v-for="(criterion, index) in criteria" :key="index" class="mv-crit-chip">
      {{ criterion.item.label }}: {{ criterion.item.type === "CHECKBOX" ? "Yes" : criterion.value }}
      <button type="button" aria-label="Remove filter" @click="remove(criterion)">✕</button>
    </span>
  </div>
</template>

<script>
import { plural } from "@/scripts/plural.js";

// Typed fields that search as they are typed in.
const TEXT_TYPES = ["STRING", "NOTE", "NUMBER"];

export default {
  props: {
    open: { type: Boolean, default: false },
    matches: { type: Number, default: 0 },
  },
  data() {
    return { TEXT_TYPES };
  },
  computed: {
    set() {
      return this.$store.state.search.metadataSet;
    },
    items() {
      return (this.set && this.set.metadata) || [];
    },
    criteria() {
      return this.$store.state.metadataCriteria();
    },
  },
  methods: {
    plural,
    // Typing searches once it pauses; a pick searches at once.
    setValue(item, value, typing) {
      this.$set(item, "value", value);
      if (typing) this.$store.state.requestAssetsSoon();
      else this.$store.state.requestAssets();
    },
    splitTags(text) {
      const tags = text
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean);
      return tags.length ? tags : undefined;
    },
    remove(criterion) {
      this.$store.state.removeMetadataCriterion(criterion);
      this.$store.state.requestAssets();
    },
    reset() {
      this.$store.state.clearMetadataCriteria();
      this.$store.state.requestAssets();
    },
  },
};
</script>
